/**
 * An object to describe the different optional feature flags that can be enabled
 * @typedef FeatureFlags
 * @property {boolean} EnabledSuppressedPaymentsValidatedResponse - Indicates that the response values with any status value should be stripped from the response
 */
module.exports = {
  "EnabledSuppressedPaymentsValidatedResponse": false
};


//////////////////
// WEBPACK FOOTER
// ./config/featureFlags.js
// module id = 26
// module chunks = 0 5 20